package com.iregained.site.components.sections.about.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.*

val AboutTrustContainerStyle = CssStyle.base {
    Modifier.fillMaxWidth().backgroundColor(colorMode.toSitePalette().custom.lightGray)
}

val AboutTrustLogoGridStyle = CssStyle.base {
    Modifier.fillMaxWidth().maxWidth(1000.px).display(DisplayStyle.Flex).flexWrap(FlexWrap.Wrap)
        .justifyContent(com.varabyte.kobweb.compose.css.JustifyContent.Center)
        .alignItems(com.varabyte.kobweb.compose.css.AlignItems.Center).gap(48.px) // Spacious gap so logos breathe
        .margin(top = 40.px)
}

val TrustLogoStyle = CssStyle {
    base {
        Modifier
            .maxHeight(size = 100.px).maxWidth(200.px) // Keeps all logos at a uniform height
            .margin(leftRight = 30.px, topBottom = 15.px)
            // Turns logos gray and slightly transparent by default
            .styleModifier { property("filter", "grayscale(0%) opacity(80%)") }
            .transition(
                Transition.of("filter", 0.3.s),
                Transition.of("transform", 0.3.s)
            )
    }
    hover {
        Modifier
            // Restores full color and opacity on hover
            .styleModifier { property("filter", "grayscale(0%) opacity(100%)") }
            .scale(1.05) // Soft pop effect
    }
}

